import React, {ReactNode, useState} from 'react';
import {Button, Flex, Progress, Tooltip, Upload, UploadFile} from "antd";
import {RcFile} from "antd/es/upload";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClose, faMusic} from "@fortawesome/free-solid-svg-icons";
import {useAppSelector} from "../feature/tools";

export interface UploadButtonProps {
    path: string
    icon?: ReactNode | undefined
    title?: ReactNode | string | undefined

    style: React.CSSProperties

    onFileUploaded: (url: string) => void

    onFileDeleted: (url: string) => void
}

export interface UploadGridProps {
    path: string
    icon?: ReactNode | undefined

    style?: React.CSSProperties

    files: string[]

    onFileUploaded: (url: string) => void

    onFileDeleted: (url: string) => void
}

export const UploadButton = (props: UploadButtonProps) => {

    const [progress, setProgress] = useState(0);
    const storageProvider = useAppSelector(state => state.storageSlice.storageProvider)

    return <Upload
        key={'upload'}
        showUploadList={false}
        customRequest={(options) => {
            const fileName = (options.file as RcFile).name
            if (storageProvider) {
                storageProvider?.upload(
                    options.file as RcFile,
                    props.path + fileName,
                    (progress) => {
                        setProgress(progress)
                    }
                ).then((url) => {
                    props.onFileUploaded(url)
                })
            }
        }}
        multiple={true}
        onRemove={(file) => {
            if (storageProvider) {
                storageProvider?.delete(
                    file.fileName as string,
                ).then((url) => {
                    props.onFileDeleted(url)
                })
            }
        }
        }>
        <Tooltip
            title={storageProvider == undefined ? 'Please select a Storage Provider first in the Project Settings' : ''}
        >
            <Button
                disabled={storageProvider == undefined || progress > 0 && progress < 100}
                style={props.style}
                icon={progress > 0 && progress < 100 ?
                    <Progress type="circle" percent={progress} size={20}/> : props.icon}>{props.title}</Button>
        </Tooltip>
    </Upload>
}

export const UploadGrid = (props: UploadGridProps) => {
    const storageProvider = useAppSelector(state => state.storageSlice.storageProvider)

    const [progress, setProgress] = useState(0);
    const files: Array<UploadFile> = props.files.map((file: string, index) => {
        return {
            uid: index.toString(),
            name: file,
            status: 'done',
            url: file
        }
    })

    return <Upload
        listType="picture-card"
        fileList={files}
        accept={'image/*,audio/mp3,*/*'}
        disabled={progress > 0 && progress < 100}
        className={'media-upload-grid'}
        multiple={true}
        itemRender={(originNode, file, currFileList, {remove}) => {
            return (
                <Flex align={'center'} justify={'center'} className="custom-item-renderer" style={{
                    width: '100px',
                    height: '100px',
                    position: "relative",
                    borderRadius: 8,
                    border: '1px solid #eee'
                }}>
                    {(file.url?.endsWith('.mp3')) ? <FontAwesomeIcon icon={faMusic} size={'2xl'}/> :
                        <img style={{width: '100px', height: '100px', borderRadius: 8, objectFit: 'cover'}}
                             src={file.url}
                             alt={file.name}/>}
                    <Button danger={true} size="small" type={'primary'} shape={'circle'}
                            icon={<FontAwesomeIcon icon={faClose}/>} onClick={remove}
                            style={{
                                position: 'absolute',
                                right: '-6px',
                                top: '-8px',
                                width: 24,
                                height: 24
                            }}/>
                </Flex>
            )
                ;
        }}
        customRequest={(options) => {
            if (storageProvider) {
                storageProvider?.upload(
                    options.file as RcFile,
                    props.path + (options.file as RcFile).name,
                    (progress) => {
                        setProgress(progress)
                    }
                ).then((url) => {
                    props.onFileUploaded(url)
                })
            }
        }}
        onRemove={(file) => {
            if (storageProvider) {
                storageProvider?.delete(
                    file.fileName as string,
                ).then((url) => {
                    props.onFileDeleted(url)
                })
            }
            return true
        }}>
        {progress > 0 && progress < 100 ?
            <Progress type="circle" percent={progress} size={20}/> : props.icon}
    </Upload>
}